export const state = () => ({
  ymClientId: null,
})
export const getters = {
  GET_YM_CLIENT_ID: (state) => state.ymClientId,
}
export const mutations = {
  SET_YM_CLIENT_ID: (state, payload: string) => {
    state.ymClientId = payload
  },
}
